import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rename',
  templateUrl: './rename.component.html',
  styleUrls: ['./rename.component.scss']
})
export class RenameComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
